module.exports = __webpack_public_path__ + "static/media/A2.6c770d6b.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/A2.png
// module id = 868
// module chunks = 0